<template>
  <div class="section two-col-section">
    <div class="section two-col-section-header">
      <div class="centered pt-4">
        <PrimaryTitle
          v-if="component.title != null"
          :title="component.title"
        ></PrimaryTitle>
      </div>
      <div class="centered pt-4">
        <span
          v-if="component.text != null"
          class="subsection-subtitle medium_grey--text"
          >{{ component.text }}</span
        >
      </div>
    </div>
    <div
      class="two-col-section-content"
      :class="tab_left ? left_color : right_color"
      v-if="component != null"
    >
      <div class="wrapper-floating-btns">
        <div class="floating-btns">
          <v-row justify="center" no-gutters>
            <v-col cols="12" sm="6">
              <div
                class="btns-item left-btn blue_1 blue_10--text"
                :class="{ 'btns-item-active': tab_left }"
                @click="change_tab('left')"
                v-if="component.left_button_title != null"
              >
                {{ component.left_button_title }}
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div
                class="btns-item right-btn greekblue_1 greekblue_10--text"
                :class="{ 'btns-item-active': !tab_left }"
                @click="change_tab('right')"
                v-if="component.right_button_title != null"
              >
                {{ component.right_button_title }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="tab_left" class="left-tab">
        <v-row dense v-if="component.left_subsection != null">
          <v-col
            v-for="(elem, id) in component.left_subsection"
            :key="id + '_left'"
            cols="12"
          >
            <SubSection :component="elem" />
          </v-col>
        </v-row>
      </div>
      <div v-else-if="!tab_left" class="right-tab">
        <v-row dense v-if="component.right_subsection != null">
          <v-col
            v-for="(elem, id) in component.right_subsection"
            :key="id + '_right'"
            cols="12"
          >
            <SubSection :component="elem" :variant_color="true" />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import SubSection from "./Subsection";
import PrimaryTitle from "./SubComponents/PrimaryTitle";

export default {
  name: "Section",
  components: { SubSection, PrimaryTitle },
  props: {
    index: {
      type: Number,
      default: 0
    },
    component: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tab_left: true,
      left_color: "blue_0",
      right_color: "greekblue_0"
    };
  },
  methods: {
    change_tab(id) {
      if (id == "left") {
        this.tab_left = true;
      } else if (id == "right") {
        this.tab_left = false;
      }
    }
  }
};
</script>

<style scoped>
.two-col-section-header {
  margin-bottom: 4.5em;
  margin-left: auto;
  margin-right: auto;
}

.wrapper-floating-btns {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.floating-btn-mobile {
  margin-bottom: 100px;
}
@media screen and (max-width: 960px) {
  .floating-btns {
    margin-bottom: 80px;
  }
}

.floating-btns {
  position: relative;
  display: inline-block;
  min-width: 500px;
  margin-top: -41px;
  height: 64px;
  border-radius: 0px 4px 4px 0px;
  box-shadow: 0 14px 24px 0 rgba(50, 49, 58, 0.25);
  z-index: 2;
  vertical-align: middle;
  background: transparent;
}

.btns-item-active {
  font-weight: 700;
}

.btns-item {
  width: 100%;
  font-size: 20px;
  color: #b1b1b1;
  float: left;
  text-align: center;
  line-height: 72px;
  cursor: pointer;
  position: relative;
}

.btns-item:not(:last-of-type)::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 14px;
  height: 40px;
  border-right: 1px solid rgba(255, 255, 255, 0.11);
}
</style>
